import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import React, { createElement, cloneElement } from 'react';
function calcLoopedSlides(slides, swiperParams) {
  var loopedSlides = Math.ceil(parseFloat(swiperParams.loopedSlides || swiperParams.slidesPerView, 10));
  loopedSlides += swiperParams.loopAdditionalSlides;
  if (loopedSlides > slides.length) {
    loopedSlides = slides.length;
  }
  return loopedSlides;
}
function renderLoop(swiper, slides, swiperParams) {
  var modifiedSlides = slides.map(function (child, index) {
    return /*#__PURE__*/cloneElement(child, {
      swiper: swiper,
      'data-swiper-slide-index': index
    });
  });
  function duplicateSlide(child, index, position) {
    return /*#__PURE__*/cloneElement(child, {
      key: "".concat(child.key, "-duplicate-").concat(index, "-").concat(position),
      className: "".concat(child.props.className || '', " ").concat(swiperParams.slideDuplicateClass)
    });
  }
  if (swiperParams.loopFillGroupWithBlank) {
    var blankSlidesNum = swiperParams.slidesPerGroup - modifiedSlides.length % swiperParams.slidesPerGroup;
    if (blankSlidesNum !== swiperParams.slidesPerGroup) {
      for (var i = 0; i < blankSlidesNum; i += 1) {
        var blankSlide = /*#__PURE__*/React.createElement("div", {
          className: "".concat(swiperParams.slideClass, " ").concat(swiperParams.slideBlankClass)
        });
        modifiedSlides.push(blankSlide);
      }
    }
  }
  if (swiperParams.slidesPerView === 'auto' && !swiperParams.loopedSlides) {
    swiperParams.loopedSlides = modifiedSlides.length;
  }
  var loopedSlides = calcLoopedSlides(modifiedSlides, swiperParams);
  var prependSlides = [];
  var appendSlides = [];
  modifiedSlides.forEach(function (child, index) {
    if (index < loopedSlides) {
      appendSlides.push(duplicateSlide(child, index, 'prepend'));
    }
    if (index < modifiedSlides.length && index >= modifiedSlides.length - loopedSlides) {
      prependSlides.push(duplicateSlide(child, index, 'append'));
    }
  });
  if (swiper) {
    swiper.loopedSlides = loopedSlides;
  }
  return [].concat(prependSlides, _toConsumableArray(modifiedSlides), appendSlides);
}
export { calcLoopedSlides, renderLoop };